import React from 'react'

interface activeProps {
  active: boolean
  left?: boolean
  right?: boolean
}

const AlgoDaoImg: React.FunctionComponent<activeProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="413"
    height="354"
    viewBox="0 0 413 354"
    fill="none"
  >
    <g filter="url(#filter0_f_15_557)">
      <ellipse
        cx="207.005"
        cy="176.995"
        rx="144.048"
        ry="102.83"
        transform="rotate(-90 207.005 176.995)"
        fill="#DA574F"
      />
    </g>
    <g filter="url(#filter1_d_15_557)">
      <circle
        cx="206.735"
        cy="177.266"
        r="151"
        transform="rotate(-90 206.735 177.266)"
        fill="white"
      />
      <circle
        cx="206.735"
        cy="177.266"
        r="150.455"
        transform="rotate(-90 206.735 177.266)"
        stroke="url(#paint0_linear_15_557)"
        strokeWidth="1.08999"
      />
    </g>
    <circle
      cx="207.006"
      cy="176.989"
      r="164.657"
      stroke="url(#paint1_linear_15_557)"
      strokeWidth="0.423959"
    />
    <circle
      cx="207.006"
      cy="176.989"
      r="164.657"
      stroke="#D95650"
      strokeOpacity="0.18"
      strokeWidth="0.423959"
    />
    <path
      d="M207.005 9.7839C299.351 9.78389 374.211 84.6446 374.211 176.99C374.211 269.335 299.351 344.196 207.005 344.196C114.66 344.196 39.7989 269.335 39.7989 176.99C39.7989 84.6447 114.66 9.7839 207.005 9.7839Z"
      stroke="url(#paint2_linear_15_557)"
      strokeWidth="0.423959"
    />
    <path
      d="M207.005 9.7839C299.351 9.78389 374.211 84.6446 374.211 176.99C374.211 269.335 299.351 344.196 207.005 344.196C114.66 344.196 39.7989 269.335 39.7989 176.99C39.7989 84.6447 114.66 9.7839 207.005 9.7839Z"
      stroke="#D95650"
      strokeOpacity="0.18"
      strokeWidth="0.423959"
    />
    <circle
      cx="207.007"
      cy="177"
      r="170.429"
      transform="rotate(-90 207.007 177)"
      stroke="url(#paint3_linear_15_557)"
      strokeWidth="0.387344"
    />
    <circle
      cx="207.001"
      cy="177"
      r="176.613"
      transform="rotate(-90 207.001 177)"
      stroke="url(#paint4_linear_15_557)"
      strokeWidth="0.774688"
    />
    <path
      d="M122.632 166.953L133.972 196.361H129.768L127.164 189.594H113.895L111.291 196.361H107.087L118.427 166.953H122.632ZM115.495 185.39H125.544L120.54 172.429L115.495 185.39ZM141.961 166.953V192.157H157.076V196.361H137.757V166.953H141.961ZM160.861 171.157C160.861 170.583 160.97 170.043 161.189 169.537C161.407 169.018 161.708 168.573 162.091 168.204C162.474 167.821 162.918 167.521 163.424 167.302C163.944 167.069 164.49 166.953 165.065 166.953H181.02C181.594 166.953 182.134 167.069 182.64 167.302C183.159 167.521 183.611 167.821 183.993 168.204C184.376 168.573 184.677 169.018 184.896 169.537C185.114 170.043 185.224 170.583 185.224 171.157V174.951H181.02V171.157H165.065V192.157H181.02V185.021H173.042V180.816H185.224V192.157C185.224 192.731 185.114 193.278 184.896 193.798C184.677 194.304 184.376 194.748 183.993 195.131C183.611 195.514 183.159 195.814 182.64 196.033C182.134 196.252 181.594 196.361 181.02 196.361H165.065C164.49 196.361 163.944 196.252 163.424 196.033C162.918 195.814 162.474 195.514 162.091 195.131C161.708 194.748 161.407 194.304 161.189 193.798C160.97 193.278 160.861 192.731 160.861 192.157V171.157ZM216.715 192.157C216.715 192.731 216.605 193.278 216.387 193.798C216.168 194.304 215.867 194.748 215.484 195.131C215.102 195.514 214.65 195.814 214.131 196.033C213.625 196.252 213.085 196.361 212.511 196.361H195.715C195.141 196.361 194.594 196.252 194.074 196.033C193.568 195.814 193.124 195.514 192.741 195.131C192.358 194.748 192.058 194.304 191.839 193.798C191.62 193.278 191.511 192.731 191.511 192.157V171.157C191.511 170.583 191.62 170.043 191.839 169.537C192.058 169.018 192.358 168.573 192.741 168.204C193.124 167.821 193.568 167.521 194.074 167.302C194.594 167.069 195.141 166.953 195.715 166.953H212.511C213.085 166.953 213.625 167.069 214.131 167.302C214.65 167.521 215.102 167.821 215.484 168.204C215.867 168.573 216.168 169.018 216.387 169.537C216.605 170.043 216.715 170.583 216.715 171.157V192.157ZM195.715 171.157V192.157H212.511V171.157H195.715Z"
      fill="#292B33"
    />
    <path
      d="M237.972 192.157C239.927 192.157 241.431 191.631 242.484 190.578C243.537 189.525 244.063 188.021 244.063 186.066V177.248C244.063 176.291 243.926 175.437 243.653 174.685C243.38 173.933 242.976 173.297 242.443 172.777C241.924 172.244 241.288 171.841 240.536 171.567C239.784 171.294 238.929 171.157 237.972 171.157H227.226V192.157H237.972ZM223.022 196.361V166.953H237.972C239.545 166.953 240.96 167.199 242.217 167.691C243.489 168.17 244.569 168.86 245.458 169.763C246.36 170.651 247.05 171.731 247.529 173.003C248.021 174.274 248.267 175.689 248.267 177.248V186.066C248.267 187.625 248.021 189.04 247.529 190.312C247.05 191.583 246.36 192.67 245.458 193.572C244.569 194.461 243.489 195.151 242.217 195.644C240.96 196.122 239.545 196.361 237.972 196.361H223.022ZM266.777 166.953L278.118 196.361H273.914L271.309 189.594H258.04L255.436 196.361H251.232L262.573 166.953H266.777ZM259.64 185.39H269.689L264.685 172.429L259.64 185.39ZM307.107 192.157C307.107 192.731 306.997 193.278 306.779 193.798C306.56 194.304 306.259 194.748 305.876 195.131C305.493 195.514 305.042 195.814 304.523 196.033C304.017 196.252 303.477 196.361 302.903 196.361H286.107C285.532 196.361 284.986 196.252 284.466 196.033C283.96 195.814 283.516 195.514 283.133 195.131C282.75 194.748 282.449 194.304 282.231 193.798C282.012 193.278 281.903 192.731 281.903 192.157V171.157C281.903 170.583 282.012 170.043 282.231 169.537C282.449 169.018 282.75 168.573 283.133 168.204C283.516 167.821 283.96 167.521 284.466 167.302C284.986 167.069 285.532 166.953 286.107 166.953H302.903C303.477 166.953 304.017 167.069 304.523 167.302C305.042 167.521 305.493 167.821 305.876 168.204C306.259 168.573 306.56 169.018 306.779 169.537C306.997 170.043 307.107 170.583 307.107 171.157V192.157ZM286.107 171.157V192.157H302.903V171.157H286.107Z"
      fill="#D7544F"
    />
    <path
      opacity="0.4"
      d="M204.54 100.765C206.766 99.9513 209.216 99.9513 211.443 100.765L260.101 118.538C261.293 118.973 261.303 120.628 260.117 121.077L211.847 139.349C209.567 140.212 207.043 140.217 204.759 139.362L155.89 121.072C154.699 120.626 154.706 118.967 155.901 118.531L204.54 100.765Z"
      fill="url(#paint5_radial_15_557)"
    />
    <g filter="url(#filter2_b_15_557)">
      <g opacity="0.8">
        <mask id="path-10-inside-1_15_557" fill="white">
          <path d="M204.539 92.6741C206.766 91.8607 209.216 91.8607 211.442 92.6741L258.608 109.902C260.32 110.528 260.334 112.904 258.63 113.549L211.846 131.259C209.566 132.122 207.042 132.126 204.759 131.272L157.387 113.541C155.676 112.901 155.686 110.518 157.402 109.892L204.539 92.6741Z" />
        </mask>
        <path
          d="M204.539 92.6741C206.766 91.8607 209.216 91.8607 211.442 92.6741L258.608 109.902C260.32 110.528 260.334 112.904 258.63 113.549L211.846 131.259C209.566 132.122 207.042 132.126 204.759 131.272L157.387 113.541C155.676 112.901 155.686 110.518 157.402 109.892L204.539 92.6741Z"
          fill="url(#paint6_radial_15_557)"
        />
        <path
          d="M157.387 113.541L157.031 114.491L157.387 113.541ZM157.402 109.892L157.749 110.844L157.402 109.892ZM211.846 131.259L211.487 130.31L211.487 130.31L211.846 131.259ZM204.759 131.272L205.114 130.322L204.759 131.272ZM258.608 109.902L258.956 108.95L258.608 109.902ZM258.63 113.549L258.989 114.497L258.989 114.497L258.63 113.549ZM211.442 92.6741L211.094 93.6267L211.442 92.6741ZM204.539 92.6741L204.191 91.7216L204.539 92.6741ZM211.094 93.6267L258.26 110.855L258.956 108.95L211.79 91.7216L211.094 93.6267ZM258.271 112.6L211.487 130.31L212.205 132.207L258.989 114.497L258.271 112.6ZM205.114 130.322L157.742 112.591L157.031 114.491L204.403 132.222L205.114 130.322ZM157.749 110.844L204.887 93.6267L204.191 91.7216L157.054 108.939L157.749 110.844ZM157.742 112.591C156.914 112.282 156.918 111.148 157.749 110.844L157.054 108.939C154.454 109.889 154.438 113.521 157.031 114.491L157.742 112.591ZM211.487 130.31C209.437 131.086 207.167 131.09 205.114 130.322L204.403 132.222C206.917 133.163 209.695 133.157 212.205 132.207L211.487 130.31ZM258.26 110.855C259.09 111.158 259.096 112.288 258.271 112.6L258.989 114.497C261.573 113.519 261.55 109.897 258.956 108.95L258.26 110.855ZM211.79 91.7216C209.339 90.8261 206.643 90.8261 204.191 91.7216L204.887 93.6267C206.889 92.8954 209.092 92.8954 211.094 93.6267L211.79 91.7216Z"
          fill="#FED0D0"
          mask="url(#path-10-inside-1_15_557)"
        />
      </g>
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M189.594 90.4623C190.383 90.4623 191.023 91.0911 191.023 91.8667L190.037 111.529C190.037 113.34 189.152 113.34 189.152 111.529L188.166 91.8667C188.166 91.0911 188.805 90.4623 189.594 90.4623Z"
      fill="url(#paint7_linear_15_557)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M219.588 103.102C220.377 103.102 221.017 103.731 221.017 104.506L220.031 122.764C220.031 124.575 219.146 124.575 219.146 122.764L218.16 104.506C218.16 103.731 218.8 103.102 219.588 103.102Z"
      fill="url(#paint8_linear_15_557)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M175.311 80.6311C176.1 80.6311 176.739 81.2599 176.739 82.0355L175.753 118.551C175.753 120.276 174.869 120.276 174.869 118.551L173.883 82.0355C173.883 81.2599 174.522 80.6311 175.311 80.6311Z"
      fill="url(#paint9_linear_15_557)"
    />
    <path
      opacity="0.3"
      d="M196.735 114.338L196.735 124.085"
      stroke="url(#paint10_linear_15_557)"
      strokeWidth="2.89745"
      strokeLinecap="round"
    />
    <path
      opacity="0.4"
      d="M202.448 100.293L202.448 108.415"
      stroke="url(#paint11_linear_15_557)"
      strokeWidth="2.89745"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M225.301 72.2045C226.09 72.2045 226.73 72.8333 226.73 73.6089L225.744 104.507C225.744 106.318 224.859 106.318 224.859 104.507L223.873 73.6089C223.873 72.8333 224.512 72.2045 225.301 72.2045Z"
      fill="url(#paint12_linear_15_557)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M246.725 89.0579C247.514 89.0579 248.153 89.6866 248.153 90.4623L247.168 112.933C247.168 114.745 246.283 114.745 246.283 112.933L245.297 90.4623C245.297 89.6866 245.936 89.0579 246.725 89.0579Z"
      fill="url(#paint13_linear_15_557)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M208.162 60C208.979 60 209.641 60.7245 209.641 61.6182L208.62 92.3648C208.62 94.4518 207.704 94.4518 207.704 92.3648L206.684 61.6182C206.684 60.7245 207.346 60 208.162 60Z"
      fill="url(#paint14_linear_15_557)"
    />
    <path
      opacity="0.3"
      d="M110.815 218.2H119.776V219.802H116.096V229.403H114.494V219.802H110.815V218.2ZM130.819 227.802C130.819 228.021 130.777 228.229 130.694 228.427C130.611 228.619 130.496 228.789 130.35 228.935C130.205 229.08 130.033 229.195 129.835 229.278C129.642 229.362 129.436 229.403 129.218 229.403H122.819C122.6 229.403 122.392 229.362 122.194 229.278C122.001 229.195 121.832 229.08 121.686 228.935C121.54 228.789 121.426 228.619 121.343 228.427C121.259 228.229 121.218 228.021 121.218 227.802V219.802C121.218 219.583 121.259 219.377 121.343 219.185C121.426 218.987 121.54 218.817 121.686 218.677C121.832 218.531 122.001 218.416 122.194 218.333C122.392 218.244 122.6 218.2 122.819 218.2H129.218C129.436 218.2 129.642 218.244 129.835 218.333C130.033 218.416 130.205 218.531 130.35 218.677C130.496 218.817 130.611 218.987 130.694 219.185C130.777 219.377 130.819 219.583 130.819 219.802V227.802ZM122.819 219.802V227.802H129.218V219.802H122.819ZM134.824 218.2V223.036L140.167 218.2H142.425L136.363 223.692L142.667 229.403H140.409L134.824 224.364V229.403H133.222V218.2H134.824ZM143.648 218.2H151.812V219.802H145.25V223.005H150.851V224.606H145.25V227.802H151.812V229.403H143.648V218.2ZM155.332 229.403H153.731V218.2H155.332L162.067 226.888V218.2H163.668V229.403H162.067L155.332 220.716V229.403ZM167.665 218.2V229.403H166.063V218.2H167.665ZM169.818 218.2H178.614V218.685L172.263 227.802H178.614V229.403H169.591V228.927L175.943 219.802H169.818V218.2ZM180.541 218.2H188.705V219.802H182.142V223.005H187.744V224.606H182.142V227.802H188.705V229.403H180.541V218.2ZM196.318 227.802C197.063 227.802 197.636 227.601 198.037 227.2C198.438 226.799 198.639 226.226 198.639 225.481V222.122C198.639 221.757 198.587 221.432 198.483 221.146C198.378 220.859 198.225 220.617 198.022 220.419C197.824 220.216 197.582 220.062 197.295 219.958C197.009 219.854 196.683 219.802 196.318 219.802H192.225V227.802H196.318ZM190.623 229.403V218.2H196.318C196.917 218.2 197.457 218.294 197.936 218.481C198.42 218.664 198.832 218.927 199.17 219.271C199.514 219.609 199.777 220.021 199.959 220.505C200.147 220.989 200.24 221.528 200.24 222.122V225.481C200.24 226.075 200.147 226.614 199.959 227.099C199.777 227.583 199.514 227.997 199.17 228.341C198.832 228.679 198.42 228.942 197.936 229.13C197.457 229.312 196.917 229.403 196.318 229.403H190.623ZM208.249 218.2V229.403H206.648V218.2H208.249ZM212.253 229.403H210.652V218.2H212.253L218.988 226.888V218.2H220.589V229.403H218.988L212.253 220.716V229.403ZM222.984 219.802C222.984 219.583 223.026 219.377 223.109 219.185C223.193 218.987 223.307 218.817 223.453 218.677C223.599 218.531 223.768 218.416 223.961 218.333C224.159 218.244 224.367 218.2 224.586 218.2H230.664C230.883 218.2 231.089 218.244 231.281 218.333C231.479 218.416 231.651 218.531 231.797 218.677C231.943 218.817 232.057 218.987 232.141 219.185C232.224 219.377 232.266 219.583 232.266 219.802V221.247H230.664V219.802H224.586V227.802H230.664V226.364H232.266V227.802C232.266 228.021 232.224 228.229 232.141 228.427C232.057 228.619 231.943 228.789 231.797 228.935C231.651 229.08 231.479 229.195 231.281 229.278C231.089 229.362 230.883 229.403 230.664 229.403H224.586C224.367 229.403 224.159 229.362 223.961 229.278C223.768 229.195 223.599 229.08 223.453 228.935C223.307 228.789 223.193 228.619 223.109 228.427C223.026 228.229 222.984 228.021 222.984 227.802V219.802ZM234.348 218.2H235.95V227.802H242.348V218.2H243.95V227.802C243.95 228.021 243.908 228.229 243.825 228.427C243.741 228.619 243.627 228.789 243.481 228.935C243.335 229.08 243.163 229.195 242.965 229.278C242.773 229.362 242.567 229.403 242.348 229.403H235.95C235.731 229.403 235.523 229.362 235.325 229.278C235.132 229.195 234.963 229.08 234.817 228.935C234.671 228.789 234.557 228.619 234.473 228.427C234.39 228.229 234.348 228.021 234.348 227.802V218.2ZM253.649 223.56C253.884 223.632 254.097 223.737 254.29 223.872C254.483 224.007 254.647 224.182 254.782 224.396C254.918 224.604 255.022 224.851 255.095 225.138C255.168 225.424 255.204 225.752 255.204 226.122V226.685C255.204 228.497 254.298 229.403 252.485 229.403H246.353V218.2H252.165C253.978 218.2 254.884 219.109 254.884 220.927V221.13C254.884 221.76 254.782 222.276 254.579 222.677C254.381 223.073 254.071 223.367 253.649 223.56ZM247.923 224.521V227.833H252.438C252.86 227.833 253.165 227.734 253.353 227.536C253.54 227.338 253.634 227.028 253.634 226.606V225.739C253.634 225.312 253.54 225.002 253.353 224.81C253.165 224.617 252.86 224.521 252.438 224.521H247.923ZM247.923 219.771V222.958H252.228C252.613 222.942 252.889 222.838 253.056 222.646C253.228 222.448 253.313 222.146 253.313 221.739V221.005C253.313 220.578 253.22 220.265 253.032 220.067C252.845 219.869 252.54 219.771 252.118 219.771H247.923ZM262.083 218.2L266.404 229.403H264.802L263.81 226.825H258.755L257.763 229.403H256.162L260.482 218.2H262.083ZM259.365 225.224H263.193L261.287 220.286L259.365 225.224ZM265.603 218.2H274.564V219.802H270.885V229.403H269.283V219.802H265.603V218.2ZM285.608 227.802C285.608 228.021 285.566 228.229 285.483 228.427C285.4 228.619 285.285 228.789 285.139 228.935C284.993 229.08 284.821 229.195 284.623 229.278C284.431 229.362 284.225 229.403 284.006 229.403H277.608C277.389 229.403 277.181 229.362 276.983 229.278C276.79 229.195 276.621 229.08 276.475 228.935C276.329 228.789 276.215 228.619 276.131 228.427C276.048 228.229 276.006 228.021 276.006 227.802V219.802C276.006 219.583 276.048 219.377 276.131 219.185C276.215 218.987 276.329 218.817 276.475 218.677C276.621 218.531 276.79 218.416 276.983 218.333C277.181 218.244 277.389 218.2 277.608 218.2H284.006C284.225 218.2 284.431 218.244 284.623 218.333C284.821 218.416 284.993 218.531 285.139 218.677C285.285 218.817 285.4 218.987 285.483 219.185C285.566 219.377 285.608 219.583 285.608 219.802V227.802ZM277.608 219.802V227.802H284.006V219.802H277.608ZM296.862 222.2C296.862 223.763 296.196 224.653 294.862 224.872L296.972 229.403H295.198L293.12 224.927H289.612V229.403H288.011V218.2H294.143C295.956 218.2 296.862 219.109 296.862 220.927V222.2ZM289.612 223.325H294.058C294.485 223.325 294.792 223.231 294.979 223.044C295.167 222.856 295.261 222.549 295.261 222.122V221.005C295.261 220.578 295.167 220.271 294.979 220.083C294.792 219.896 294.485 219.802 294.058 219.802H289.612V223.325ZM150.025 240.2L154.346 251.403H152.744L151.752 248.825H146.697L145.705 251.403H144.104L148.424 240.2H150.025ZM147.307 247.224H151.135L149.229 242.286L147.307 247.224ZM157.389 251.403H155.788V240.2H157.389L164.124 248.888V240.2H165.725V251.403H164.124L157.389 242.716V251.403ZM173.815 249.802C174.56 249.802 175.133 249.601 175.534 249.2C175.935 248.799 176.136 248.226 176.136 247.481V244.122C176.136 243.757 176.084 243.432 175.979 243.146C175.875 242.859 175.722 242.617 175.519 242.419C175.321 242.216 175.078 242.062 174.792 241.958C174.505 241.854 174.18 241.802 173.815 241.802H169.722V249.802H173.815ZM168.12 251.403V240.2H173.815C174.414 240.2 174.953 240.294 175.433 240.481C175.917 240.664 176.328 240.927 176.667 241.271C177.011 241.609 177.274 242.021 177.456 242.505C177.644 242.989 177.737 243.528 177.737 244.122V247.481C177.737 248.075 177.644 248.614 177.456 249.099C177.274 249.583 177.011 249.997 176.667 250.341C176.328 250.679 175.917 250.942 175.433 251.13C174.953 251.312 174.414 251.403 173.815 251.403H168.12ZM185.746 246.606C185.527 246.606 185.319 246.565 185.121 246.481C184.928 246.393 184.759 246.278 184.613 246.138C184.467 245.992 184.353 245.823 184.269 245.63C184.186 245.432 184.144 245.224 184.144 245.005V241.802C184.144 241.583 184.186 241.377 184.269 241.185C184.353 240.987 184.467 240.817 184.613 240.677C184.759 240.531 184.928 240.416 185.121 240.333C185.319 240.244 185.527 240.2 185.746 240.2H191.184C191.402 240.2 191.608 240.244 191.801 240.333C191.999 240.416 192.17 240.531 192.316 240.677C192.462 240.817 192.577 240.987 192.66 241.185C192.743 241.377 192.785 241.583 192.785 241.802V243.247H191.184V241.802H185.746V245.005H191.184C191.402 245.005 191.608 245.047 191.801 245.13C191.999 245.213 192.17 245.328 192.316 245.474C192.462 245.619 192.577 245.791 192.66 245.989C192.743 246.182 192.785 246.388 192.785 246.606V249.802C192.785 250.021 192.743 250.229 192.66 250.427C192.577 250.619 192.462 250.789 192.316 250.935C192.17 251.08 191.999 251.195 191.801 251.278C191.608 251.362 191.402 251.403 191.184 251.403H185.59C185.371 251.403 185.163 251.362 184.965 251.278C184.772 251.195 184.603 251.08 184.457 250.935C184.311 250.789 184.197 250.619 184.113 250.427C184.03 250.229 183.988 250.021 183.988 249.802V248.364H185.59V249.802H191.184V246.606H185.746ZM195.938 240.2L199.196 245.435L202.461 240.2H204.321L200 246.958V251.403H198.399V246.958L194.078 240.2H195.938ZM207.208 246.606C206.989 246.606 206.781 246.565 206.583 246.481C206.39 246.393 206.221 246.278 206.075 246.138C205.929 245.992 205.815 245.823 205.731 245.63C205.648 245.432 205.606 245.224 205.606 245.005V241.802C205.606 241.583 205.648 241.377 205.731 241.185C205.815 240.987 205.929 240.817 206.075 240.677C206.221 240.531 206.39 240.416 206.583 240.333C206.781 240.244 206.989 240.2 207.208 240.2H212.645C212.864 240.2 213.07 240.244 213.263 240.333C213.46 240.416 213.632 240.531 213.778 240.677C213.924 240.817 214.039 240.987 214.122 241.185C214.205 241.377 214.247 241.583 214.247 241.802V243.247H212.645V241.802H207.208V245.005H212.645C212.864 245.005 213.07 245.047 213.263 245.13C213.46 245.213 213.632 245.328 213.778 245.474C213.924 245.619 214.039 245.791 214.122 245.989C214.205 246.182 214.247 246.388 214.247 246.606V249.802C214.247 250.021 214.205 250.229 214.122 250.427C214.039 250.619 213.924 250.789 213.778 250.935C213.632 251.08 213.46 251.195 213.263 251.278C213.07 251.362 212.864 251.403 212.645 251.403H207.052C206.833 251.403 206.625 251.362 206.427 251.278C206.234 251.195 206.065 251.08 205.919 250.935C205.773 250.789 205.658 250.619 205.575 250.427C205.492 250.229 205.45 250.021 205.45 249.802V248.364H207.052V249.802H212.645V246.606H207.208ZM215.697 240.2H224.658V241.802H220.978V251.403H219.376V241.802H215.697V240.2ZM226.099 240.2H234.263V241.802H227.701V245.005H233.303V246.606H227.701V249.802H234.263V251.403H226.099V240.2ZM241.963 251.403L237.783 243.192V251.403H236.182V240.2H237.932L242.198 248.638L246.471 240.2H248.213V251.403H246.619V243.192L242.44 251.403H241.963ZM251.6 244.927H250.468L251.616 242.536H250.468V240.2H252.803V242.536L251.6 244.927ZM256.323 246.606C256.105 246.606 255.896 246.565 255.698 246.481C255.506 246.393 255.337 246.278 255.191 246.138C255.045 245.992 254.93 245.823 254.847 245.63C254.764 245.432 254.722 245.224 254.722 245.005V241.802C254.722 241.583 254.764 241.377 254.847 241.185C254.93 240.987 255.045 240.817 255.191 240.677C255.337 240.531 255.506 240.416 255.698 240.333C255.896 240.244 256.105 240.2 256.323 240.2H261.761C261.98 240.2 262.185 240.244 262.378 240.333C262.576 240.416 262.748 240.531 262.894 240.677C263.04 240.817 263.154 240.987 263.238 241.185C263.321 241.377 263.363 241.583 263.363 241.802V243.247H261.761V241.802H256.323V245.005H261.761C261.98 245.005 262.185 245.047 262.378 245.13C262.576 245.213 262.748 245.328 262.894 245.474C263.04 245.619 263.154 245.791 263.238 245.989C263.321 246.182 263.363 246.388 263.363 246.606V249.802C263.363 250.021 263.321 250.229 263.238 250.427C263.154 250.619 263.04 250.789 262.894 250.935C262.748 251.08 262.576 251.195 262.378 251.278C262.185 251.362 261.98 251.403 261.761 251.403H256.167C255.948 251.403 255.74 251.362 255.542 251.278C255.35 251.195 255.18 251.08 255.034 250.935C254.889 250.789 254.774 250.619 254.691 250.427C254.607 250.229 254.566 250.021 254.566 249.802V248.364H256.167V249.802H261.761V246.606H256.323ZM121.863 263.802C121.863 263.583 121.904 263.377 121.988 263.185C122.071 262.987 122.185 262.817 122.331 262.677C122.477 262.531 122.646 262.416 122.839 262.333C123.037 262.244 123.245 262.2 123.464 262.2H129.542C129.761 262.2 129.967 262.244 130.159 262.333C130.357 262.416 130.529 262.531 130.675 262.677C130.821 262.817 130.935 262.987 131.019 263.185C131.102 263.377 131.144 263.583 131.144 263.802V265.247H129.542V263.802H123.464V271.802H129.542V269.083H126.503V267.481H131.144V271.802C131.144 272.021 131.102 272.229 131.019 272.427C130.935 272.619 130.821 272.789 130.675 272.935C130.529 273.08 130.357 273.195 130.159 273.278C129.967 273.362 129.761 273.403 129.542 273.403H123.464C123.245 273.403 123.037 273.362 122.839 273.278C122.646 273.195 122.477 273.08 122.331 272.935C122.185 272.789 122.071 272.619 121.988 272.427C121.904 272.229 121.863 272.021 121.863 271.802V263.802ZM143.14 271.802C143.14 272.021 143.099 272.229 143.015 272.427C142.932 272.619 142.817 272.789 142.672 272.935C142.526 273.08 142.354 273.195 142.156 273.278C141.963 273.362 141.758 273.403 141.539 273.403H135.14C134.922 273.403 134.713 273.362 134.515 273.278C134.323 273.195 134.153 273.08 134.008 272.935C133.862 272.789 133.747 272.619 133.664 272.427C133.58 272.229 133.539 272.021 133.539 271.802V263.802C133.539 263.583 133.58 263.377 133.664 263.185C133.747 262.987 133.862 262.817 134.008 262.677C134.153 262.531 134.323 262.416 134.515 262.333C134.713 262.244 134.922 262.2 135.14 262.2H141.539C141.758 262.2 141.963 262.244 142.156 262.333C142.354 262.416 142.526 262.531 142.672 262.677C142.817 262.817 142.932 262.987 143.015 263.185C143.099 263.377 143.14 263.583 143.14 263.802V271.802ZM135.14 263.802V271.802H141.539V263.802H135.14ZM148.903 273.403L144.582 262.2H146.301L149.785 271.419L153.278 262.2H154.989L150.668 273.403H148.903ZM156.423 262.2H164.587V263.802H158.024V267.005H163.626V268.606H158.024V271.802H164.587V273.403H156.423V262.2ZM175.357 266.2C175.357 267.763 174.69 268.653 173.357 268.872L175.466 273.403H173.693L171.614 268.927H168.107V273.403H166.505V262.2H172.638C174.45 262.2 175.357 263.109 175.357 264.927V266.2ZM168.107 267.325H172.552C172.979 267.325 173.286 267.231 173.474 267.044C173.661 266.856 173.755 266.549 173.755 266.122V265.005C173.755 264.578 173.661 264.271 173.474 264.083C173.286 263.896 172.979 263.802 172.552 263.802H168.107V267.325ZM179.158 273.403H177.556V262.2H179.158L185.892 270.888V262.2H187.494V273.403H185.892L179.158 264.716V273.403ZM194.85 262.2L199.17 273.403H197.568L196.576 270.825H191.522L190.529 273.403H188.928L193.248 262.2H194.85ZM192.131 269.224H195.959L194.053 264.286L192.131 269.224ZM202.214 273.403H200.612V262.2H202.214L208.948 270.888V262.2H210.549V273.403H208.948L202.214 264.716V273.403ZM212.944 263.802C212.944 263.583 212.986 263.377 213.069 263.185C213.153 262.987 213.267 262.817 213.413 262.677C213.559 262.531 213.728 262.416 213.921 262.333C214.119 262.244 214.327 262.2 214.546 262.2H220.624C220.843 262.2 221.049 262.244 221.241 262.333C221.439 262.416 221.611 262.531 221.757 262.677C221.903 262.817 222.017 262.987 222.101 263.185C222.184 263.377 222.226 263.583 222.226 263.802V265.247H220.624V263.802H214.546V271.802H220.624V270.364H222.226V271.802C222.226 272.021 222.184 272.229 222.101 272.427C222.017 272.619 221.903 272.789 221.757 272.935C221.611 273.08 221.439 273.195 221.241 273.278C221.049 273.362 220.843 273.403 220.624 273.403H214.546C214.327 273.403 214.119 273.362 213.921 273.278C213.728 273.195 213.559 273.08 213.413 272.935C213.267 272.789 213.153 272.619 213.069 272.427C212.986 272.229 212.944 272.021 212.944 271.802V263.802ZM224.308 262.2H232.472V263.802H225.91V267.005H231.511V268.606H225.91V271.802H232.472V273.403H224.308V262.2ZM240.309 262.2V271.802H246.067V273.403H238.708V262.2H240.309ZM252.47 262.2L256.79 273.403H255.188L254.196 270.825H249.142L248.149 273.403H246.548L250.868 262.2H252.47ZM249.751 269.224H253.579L251.673 264.286L249.751 269.224ZM257.693 262.2L260.951 267.435L264.216 262.2H266.076L261.755 268.958V273.403H260.154V268.958L255.833 262.2H257.693ZM267.361 262.2H275.525V263.802H268.963V267.005H274.564V268.606H268.963V271.802H275.525V273.403H267.361V262.2ZM286.295 266.2C286.295 267.763 285.629 268.653 284.295 268.872L286.405 273.403H284.631L282.553 268.927H279.045V273.403H277.444V262.2H283.577C285.389 262.2 286.295 263.109 286.295 264.927V266.2ZM279.045 267.325H283.491C283.918 267.325 284.225 267.231 284.413 267.044C284.6 266.856 284.694 266.549 284.694 266.122V265.005C284.694 264.578 284.6 264.271 284.413 264.083C284.225 263.896 283.918 263.802 283.491 263.802H279.045V267.325Z"
      fill="#1D1E1F"
    />
    <g opacity={props.active ? 1 : 0.2}>
      <path
        d="M407.001 171C407.001 119 365.001 92 339.001 58"
        stroke="url(#paint15_linear_15_557)"
        strokeLinecap="round"
      />
      <path
        d="M404.001 175C390.112 175 384.001 161.755 374.001 116"
        stroke="url(#paint16_linear_15_557)"
        strokeLinecap="round"
      />
      <path
        d="M404.001 176C390.112 176 384.001 189.245 374.001 235"
        stroke="url(#paint17_linear_15_557)"
        strokeLinecap="round"
      />
      <path
        d="M407.001 180C407.001 232 365.001 259 339.001 293"
        stroke="url(#paint18_linear_15_557)"
        strokeLinecap="round"
      />
      <rect
        x="410.501"
        y="179.5"
        width="8"
        height="8"
        rx="4"
        transform="rotate(180 410.501 179.5)"
        stroke="#D94F56"
        strokeWidth="5"
      />
    </g>
    <g opacity={props.left ? 1 : 0.2}>
      <path
        d="M6.00098 171C6.00098 119 48.001 92 74.001 58"
        stroke="url(#paint19_linear_15_557)"
        strokeLinecap="round"
      />
      <path
        d="M9.00098 175C22.8899 175 29.001 161.755 39.001 116"
        stroke="url(#paint20_linear_15_557)"
        strokeLinecap="round"
      />
      <path
        d="M9.00098 176C22.8899 176 29.001 189.245 39.001 235"
        stroke="url(#paint21_linear_15_557)"
        strokeLinecap="round"
      />
      <path
        d="M6.00098 180C6.00097 232 48.001 259 74.001 293"
        stroke="url(#paint22_linear_15_557)"
        strokeLinecap="round"
      />
      <rect
        x="2.5"
        y="-2.5"
        width="8"
        height="8"
        rx="4"
        transform="matrix(1 4.37114e-08 4.37114e-08 -1 0.00097697 177)"
        stroke="#D94F56"
        strokeWidth="5"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_15_557"
        x="71.5299"
        y="0.302879"
        width="270.951"
        height="353.385"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="16.3224"
          result="effect1_foregroundBlur_15_557"
        />
      </filter>
      <filter
        id="filter1_d_15_557"
        x="39.2985"
        y="9.82891"
        width="334.874"
        height="334.874"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8.21842" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.116667 0 0 0 0 0.0543499 0 0 0 0 0.0476389 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_15_557"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_15_557"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_b_15_557"
        x="153.909"
        y="89.8641"
        width="108.191"
        height="44.2453"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation="1.1" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_15_557"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_15_557"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_15_557"
        x1="315.026"
        y1="284.259"
        x2="92.8407"
        y2="82.3506"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D7544F" />
        <stop offset="0.239249" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="0.716165" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="1" stopColor="#D7544F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_15_557"
        x1="325.244"
        y1="293.809"
        x2="82.651"
        y2="73.3561"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D7544F" />
        <stop offset="0.239249" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="0.716165" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="1" stopColor="#D7544F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_15_557"
        x1="325.632"
        y1="56.9245"
        x2="101.77"
        y2="303.268"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D7544F" />
        <stop offset="0.239249" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="0.716165" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="1" stopColor="#D7544F" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_15_557"
        x1="329.371"
        y1="297.898"
        x2="78.3111"
        y2="69.7504"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D7544F" />
        <stop offset="0.239249" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="0.716165" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="1" stopColor="#D7544F" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_15_557"
        x1="198.052"
        y1="348.531"
        x2="209.487"
        y2="2.48594"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D7544F" />
        <stop offset="0.239249" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="0.716165" stopColor="#D7544F" stopOpacity="0" />
        <stop offset="1" stopColor="#D7544F" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_15_557"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(208.001 120.077) rotate(159.829) scale(49.9327 32.3325)"
      >
        <stop stopColor="#AEAEAE" stopOpacity="0.65" />
        <stop offset="1" stopColor="#A9A9A9" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_15_557"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(208.005 111.987) rotate(159.435) scale(49.017 32.2502)"
      >
        <stop offset="0.0345502" stopColor="#E47272" stopOpacity="0.36" />
        <stop offset="1" stopColor="#E16C6C" />
      </radialGradient>
      <linearGradient
        id="paint7_linear_15_557"
        x1="190.087"
        y1="91.8667"
        x2="190.087"
        y2="111.529"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.186384" stopColor="#A7A7A7" />
        <stop offset="1" stopColor="#A7A7A7" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_15_557"
        x1="220.081"
        y1="104.506"
        x2="220.081"
        y2="122.764"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DD676D" />
        <stop offset="1" stopColor="#DD676D" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_15_557"
        x1="175.804"
        y1="82.0355"
        x2="175.804"
        y2="118.551"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.578328" stopColor="#E17C81" />
        <stop offset="1" stopColor="#E17C81" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_15_557"
        x1="197.235"
        y1="114.338"
        x2="197.235"
        y2="124.085"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D74E55" />
        <stop offset="1" stopColor="#D74E55" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_15_557"
        x1="202.948"
        y1="100.293"
        x2="202.948"
        y2="108.415"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D74E55" />
        <stop offset="1" stopColor="#D74E55" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_15_557"
        x1="225.794"
        y1="73.6089"
        x2="225.794"
        y2="104.507"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.166667" stopColor="#C3C3C3" />
        <stop offset="1" stopColor="#C3C3C3" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_15_557"
        x1="247.218"
        y1="90.4623"
        x2="247.218"
        y2="112.933"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.610377" stopColor="#DE6B71" />
        <stop offset="1" stopColor="#DE6B71" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_15_557"
        x1="208.673"
        y1="61.6182"
        x2="208.673"
        y2="92.3648"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DF6E74" />
        <stop offset="1" stopColor="#DF6E74" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_15_557"
        x1="409.501"
        y1="167.5"
        x2="313.771"
        y2="138.615"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.581785" stopColor="#D7544F" />
        <stop offset="1" stopColor="#D7544F" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_15_557"
        x1="404.557"
        y1="175"
        x2="362.726"
        y2="160.689"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.581785" stopColor="#D7544F" />
        <stop offset="1" stopColor="#D7544F" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_15_557"
        x1="404.557"
        y1="176"
        x2="362.726"
        y2="190.311"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.581785" stopColor="#D7544F" />
        <stop offset="1" stopColor="#D7544F" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_15_557"
        x1="409.501"
        y1="183.5"
        x2="313.771"
        y2="212.385"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.581785" stopColor="#D7544F" />
        <stop offset="1" stopColor="#D7544F" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_15_557"
        x1="3.50098"
        y1="167.5"
        x2="99.2308"
        y2="138.615"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.581785" stopColor="#D7544F" />
        <stop offset="1" stopColor="#D7544F" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_15_557"
        x1="8.44542"
        y1="175"
        x2="50.2761"
        y2="160.689"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.581785" stopColor="#D7544F" />
        <stop offset="1" stopColor="#D7544F" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_15_557"
        x1="8.44542"
        y1="176"
        x2="50.2761"
        y2="190.311"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.581785" stopColor="#D7544F" />
        <stop offset="1" stopColor="#D7544F" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_15_557"
        x1="3.50098"
        y1="183.5"
        x2="99.2308"
        y2="212.385"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.581785" stopColor="#D7544F" />
        <stop offset="1" stopColor="#D7544F" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default AlgoDaoImg
